<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true,
    };
  },

  methods: {
    reload(){
      this.isRouterAlive=false;
      this.$nextTick(function(){
        this.isRouterAlive=true
      })
    }
  },
}
</script>

<style lang="less">
  #app{
    width: 100%;
    min-width: 1280px;
    overflow-x: clip;
    // overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue